import { Envs } from "./@types";
import { getEnvironment } from "./helpers/urlHelpers";

const DEBUG = process.env.NODE_ENV === "development";
const env = getEnvironment();

function mctApiHost(): string {
  if (DEBUG) {
    return "//localhost:8080";
  }
  if (window.location.hostname.includes("s3-website")) {
    return "//test.medicare.gov";
  }
  return "";
}

const FE_VERSION: string = import.meta.env.VITE_RELEASE_VERSION || "Unknown";

const MCTAPI_PATH: string = DEBUG ? "" : "/api/v1/data/plan-compare";
const mctApiFullUrl = `${mctApiHost()}${MCTAPI_PATH}`;
const MCTAPI_URI: string = import.meta.env.VITE_MCTAPI_URI || mctApiFullUrl;

const CONNECT_BASE_URL: string =
  import.meta.env.VITE_CONNECT_BASE_URL ||
  (env === Envs.local ? "http://localhost:8081" : mctApiFullUrl);

// Launch Darkly Variables
const LD_BASE_URL = import.meta.env.VITE_LD_BASE_URL || "Not Set";
const LD_CLIENT_ID = import.meta.env.VITE_LD_CLIENT_ID || "Not Set";
const LD_EVENTS_URL = import.meta.env.VITE_LD_EVENTS_URL || "Not Set";
const LD_STREAM_URL = import.meta.env.VITE_LD_STREAM_URL || "Not Set";

// Mapbox Variables
const MAPBOX_ACCESS_TOKEN = import.meta.env.VITE_MAPBOX_ACCESS_TOKEN || false;
export const NEW_RELIC_BROWSER_API_KEY = import.meta.env
  .VITE_NEW_RELIC_BROWSER_API_KEY;

const ANON_ENROLL_BASE_URL =
  import.meta.env.VITE_ANON_ENROLL_BASE_URL ||
  "https://test.enrollmentcenter.medicare.gov";

const FORCE_LOGOUT_TIMEOUT_MINUTES = isNaN(
  import.meta.env.VITE_FORCE_LOGOUT_TIMEOUT_MINUTES as unknown as number
)
  ? null
  : Number(import.meta.env.VITE_FORCE_LOGOUT_TIMEOUT_MINUTES);

const CSR_IDLE_TIMEOUT_MINUTES = isNaN(
  import.meta.env.VITE_CSR_IDLE_TIMEOUT_MINUTES as unknown as number
)
  ? null
  : Number(import.meta.env.VITE_CSR_IDLE_TIMEOUT_MINUTES);

const CSR_FORCE_LOGOUT_TIMEOUT_MINUTES = isNaN(
  import.meta.env.VITE_CSR_FORCE_LOGOUT_TIMEOUT_MINUTES as unknown as number
)
  ? null
  : Number(import.meta.env.VITE_CSR_FORCE_LOGOUT_TIMEOUT_MINUTES);

const FORCE_LOGOUT_TIMEOUT_INFO =
  import.meta.env.VITE_FORCE_LOGOUT_TIMEOUT_INFO === "true" &&
  env !== Envs.prod;

export const DISABLE_REACT_QUERY_DEVTOOLS =
  import.meta.env.VITE_DISABLE_REACT_QUERY_DEVTOOLS === "true" &&
  env !== Envs.prod;

export const DISABLE_IDLE_TIMEOUT =
  import.meta.env.VITE_DISABLE_IDLE_TIMEOUT === "true" && env !== Envs.prod;

export const MCT_APP_MAIN_ID = import.meta.env.VITE_MCT_APP_MAIN_ID;
export const MCT_GLOBAL_SKIP_NAV_ID = import.meta.env
  .VITE_MCT_GLOBAL_SKIP_NAV_ID;
export const MCT_SR_TITLE_ID = import.meta.env.VITE_MCT_SR_TITLE_ID;
export const MCT_ROOT_ID = import.meta.env.VITE_MCT_ROOT_ID;
export const MCT_PORTAL_ROOT_ID = import.meta.env.VITE_MCT_PORTAL_ROOT_ID;
export const TESTING =
  import.meta.env.VITE_TESTING === "true" ||
  import.meta.env.MODE === "test" ||
  !!window.playwright;
export const ENABLE_LOCAL_NEWRELIC =
  import.meta.env.VITE_ENABLE_LOCAL_NEWRELIC === "true";
export const ENABLE_DEBUG_LOGGING =
  import.meta.env.VITE_ENABLE_DEBUG_LOGGING === "true";

declare global {
  interface Window {
    config: Record<string, unknown>;
  }
}

export const config = (window.config = {
  ANON_ENROLL_BASE_URL,
  CONNECT_BASE_URL,
  CSR_FORCE_LOGOUT_TIMEOUT_MINUTES,
  CSR_IDLE_TIMEOUT_MINUTES,
  DEBUG,
  DISABLE_IDLE_TIMEOUT,
  DISABLE_REACT_QUERY_DEVTOOLS,
  ENABLE_DEBUG_LOGGING,
  ENABLE_LOCAL_NEWRELIC,
  FE_VERSION,
  FORCE_LOGOUT_TIMEOUT_INFO,
  FORCE_LOGOUT_TIMEOUT_MINUTES,
  MAPBOX_ACCESS_TOKEN,
  MCT_APP_MAIN_ID,
  MCT_GLOBAL_SKIP_NAV_ID,
  MCT_ROOT_ID,
  MCT_PORTAL_ROOT_ID,
  MCT_SR_TITLE_ID,
  MCTAPI_URI,
  LD_BASE_URL,
  LD_CLIENT_ID,
  LD_EVENTS_URL,
  LD_STREAM_URL,
  NEW_RELIC_BROWSER_API_KEY,
  TESTING,
});
